/**
 * Created by harry.preiss on 22 Jun 2020
 */

import {Action, Module, Mutation} from 'vuex-module-decorators'
import store from "@/store";
import {MdbsCore} from "@/api/tsclient";
import BaseModule from "@/store/modules/BaseModule";
import UsersToInstituteAssignmentDto = MdbsCore.UsersToInstituteAssignmentDto;
import UserToInstitutesAssignmentDto = MdbsCore.UserToInstitutesAssignmentDto;
import IStudyInstituteShortDto = MdbsCore.IStudyInstituteShortDto;
import StudyInstituteShortDto = MdbsCore.StudyInstituteShortDto;

const instituteAssignmentClient = new MdbsCore.InstituteAssignmentClient();

@Module({namespaced: true, name: 'instituteAssignment', store: store})
export default class InstituteAssignmentModule extends BaseModule {

    private _currentStudyInstitute: IStudyInstituteShortDto = new StudyInstituteShortDto();

    get currentStudyInstitute(): IStudyInstituteShortDto {
        return this._currentStudyInstitute;
    }

    get hasCurrentStudyInstitute(): boolean {
        return !!this._currentStudyInstitute.id;
    }

    @Mutation
    resetAll() {
        this._currentStudyInstitute = new StudyInstituteShortDto();
    }

    @Mutation
    setCurrentStudyInstitute(studyInstitute: IStudyInstituteShortDto) {
        this._currentStudyInstitute = studyInstitute;
    }

    @Mutation
    resetCurrentStudyInstitute() {
        this._currentStudyInstitute = new StudyInstituteShortDto();
    }

    @Action({rawError: true})
    async assignInstitutesToUser(payload: { userId: string, instituteIds: string[] }) {
        const {userId, instituteIds} = payload;

        const assignmentDto = new UserToInstitutesAssignmentDto()
        {
            assignmentDto.id = userId;
            assignmentDto.instituteIds = instituteIds;
        }

        await this.execute(async () =>
            await instituteAssignmentClient.updateUserToInstitutesAssignments(userId, assignmentDto)
        );
    }

    @Action({rawError: true})
    async assignUsersToInstitute(payload: { instituteId: string, userIds: string[] }) {
        const {instituteId, userIds} = payload;

        const assignmentDto = new UsersToInstituteAssignmentDto();
        {
            assignmentDto.id = instituteId;
            assignmentDto.userIds = userIds;
        }

        await this.execute(async () =>
            await instituteAssignmentClient.updateUsersToInstituteAssignments(instituteId, assignmentDto)
        );
    }
}